import { gql, useMutation, MutationHookOptions } from '@apollo/client';
import { UserPreference, UserPreferenceInput } from 'tuapath-common/generated/schema';

type Variables = { input: UserPreferenceInput[] };
type Result = { updateUserPreferences: UserPreference };
export const useUpdateUserPreferences = (options?: MutationHookOptions<Result, Variables>) => {
  const mutation = gql`
    mutation updateUserPreferences($input: [UserPreferenceInput]!) {
      updateUserPreferences(input: $input)
    }
  `;

  return useMutation<Result, Variables>(mutation);
};
